import {Stack} from '@mantine/core';

Stack.displayName = 'Stack';

export {Stack, type StackFactory, type StackProps} from '@mantine/core';
